<template>
  <div class="nav">
    <div v-for="(item, index) in menu" :key="`${item.name}-${item.value}-${index}`">
      <div v-if="item.value !== 2">
        <!-- 0禁用1启用2隐藏 -->
        <div class="nav-item" v-show="item.showStatus || item.showStatus == undefined">
          <div class="nav-item-title" :class="{ active: item.path ? active.indexOf(item[activeKey]) > -1 : active === item[activeKey], nav: activeKey === 'path' }" @click="change(item)">
            <!-- <svg-icon v-if="item.icon" :name="item.icon"></svg-icon> -->
            <svg-icon v-if="item.value === 0" name="suo"></svg-icon>
            <span :class="item.value === 0 ? 'ncole' : ''">
              {{ $t(item.name) }}
            </span>
            <!-- <div v-if="item.namet == 'marketing_research' && showTipP" class="open-popover">
              <el-popover id="showTipTest" placement="bottom-start" v-model="showTipP">
                <div class="open-popover-cont">
                  {{ $i18.language('市场研究报告，限时体验活动进行中！ 您可联系「总览」页面右侧的专属客服，') }}<span class="hoverTipsContSpan" @click="openTips">{{ $i18.language('申请开通。') }}</span>
                </div>
              </el-popover>
            </div> -->
          </div>
          <!-- <hr :class="{active: item.path?active.indexOf(item[activeKey]) > -1:active=== item[activeKey],nav: activeKey==='path'}" /> -->
        </div>
      </div>
    </div>
     
    <div v-if="AiGptShow !== 2" class="nav-item aigpt" @click="openAI">
      <svg-icon v-if="AiGptShow === 0" name="suo"></svg-icon>
      <div class="aigpt-box">
        <el-image :class="AiGptShow === 0 ? 'ncole' : ''" fit="contain" :src="require('@/assets/AIGPT/AIChat.png')"></el-image>
        <span>TradeGPT</span>
        <svg-icon class="beta" name="beta"></svg-icon>
      </div>
    </div>
    <tipOpen ref="openTips" @changeStatus="changeStatus"></tipOpen>
  </div>
</template>

<script>
import tipOpen from '@/components/tipsDialog/tipOpen'
export default {
  name: 'navBar',
  props: {
    menu: {
      type: Array,
      required: true,
    },
    active: {
      type: [String, Number],
    },
    activeKey: {
      type: String,
      required: true,
    },
  },
  components: {
    tipOpen,
  },
  watch: {
    menu: {
      handler(val){
        console.log(val, 'watch-header-bar');
        let getRules = JSON.parse(localStorage.getItem('gt6_getRules'))
        if (getRules) {
          this.AiGptShow = JSON.parse(localStorage.getItem('gt6_getRules')).extendRule.allowAiGpt
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      showTipP: false,
      visit: '',
      langShow: localStorage.getItem('language') == 'en' ? false : true,
      AiGptShow: 2,
    }
  },
  mounted() {
    document.addEventListener('click', (e) => {
      let list = document.getElementById('help-cont')
      this.$nextTick(()=>{
          if (!list.contains(e.target)&&this.showTipP) {
            this.showTipP=false
            this.changeStatus()
          }
      })
    })
  },
  created() {
    if(this.$util.isLogin()){
      this.getStatus()
    }
  },
  methods: {
    change(item) {
      this.$store.commit('curren_meun_data', item.name)
      this.$emit('change', item)
    },
    openTips() {
      this.$refs.openTips.dialogOpen = true
    },
    getStatus() {
      // this.$api.user.getShowOpenButton({ visit: this.visit }).then((res) => {
      //   this.showTipP=res.data
      // })
    },
    changeStatus() {
      this.visit = true
      this.getStatus()
    },
    openAI(){
      if (this.AiGptShow !== 0) {
        this.$router.push('/aigpt')
      } else {
        return this.$message.warning(this.$i18.language('「该模块白银版及以上版本用户开放」'))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-popover {
  top: 21px;
  left: -54px;
  font-size: 12px;
  width: 258px;
}
.open-popover {
  white-space: normal;
  position: relative;
  .open-popover-cont {
    line-height: 25px;
  }
}
.hoverTipsContSpan {
  color: $--color-primary-6;
  cursor: pointer;
}
.aclss {
  text-decoration: none;
  color: #1a173b;
  font-size: 14px;
  line-height: 1;
}
.nav {
  display: flex;
  height: 100%;
  .nav-item {
    margin: 0 15px;
    line-height: 60px;
    .nav-item-title {
      .ncole {
        opacity: 0.5;
      }
      min-width: 3em;
      cursor: pointer;
      height: 100%;
      vertical-align: middle;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      &.active {
        color: $--color-link;
        font-weight: 500;
        &.nav {
          // color: $--color-default;
        }
      }
      .svg-icon {
        margin-right: 4px;
      }
    }
    hr {
      display: none;
      width: 100%;
      margin: 0 auto;
      &.active {
        display: block;
        background-color: $--color-link;
        height: 3px;
        border: none;
      }

      &.nav {
        background-color: #ffffff;
      }
    }
  }
  .aigpt {
    cursor: pointer;
    line-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .ncole {
      padding-left: 5px;
      opacity: 0.5;
    }
    .aigpt-box {
      position: relative;
      .beta {
        position: absolute;
        top: -6px;
        right: -15px;
        width: 27px;
        height: 19px;
      }
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: $--color-white;
      }
    }
  }
}
</style>
